<template>
    <transition name="fade">
        <div v-if="mainPageShow">index</div>
    </transition>
</template>

<script>
    let dataObj={
        requestUrl:websiteConfig.commonRequestUrl,
        tkName:websiteConfig.tokenStringName,
        token:getLocalStorage(websiteConfig.tokenStringName),
        accountBaseInfo:websiteConfig.commonUserInfo,
        mainPageShow:false
    };
    export default {
        data(){
            return dataObj
        },
        components:{},
        methods: {},
        created(){},
        mounted(){
            let _this=this;
            _this.mainPageShow=true;
            window.location.href="login.html";
            window.onload=function(){
                loadScript("https://qiyukf.com/script/debae06a181a195ea71396d3f3933069.js?hidden=1",function(){});
            }
        }
    }
</script>

<style>
    /**********/
    .fade-enter-active,.fade-leave-active{
        transition: opacity .5s;
    }
    .fade-enter,.fade-leave-to{
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/component/Index.vue